// app/frontend/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes
})

let authChecked = false

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // Check auth status on first navigation
  if (!authChecked) {
    await authStore.checkAuth()
    authChecked = true
  }

  // Route requires authentication
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    next({ name: 'Login' })
    return
  }

  // Route is for guests only (login, signup)
  if (to.meta.guest && authStore.isLoggedIn) {
    // Redirect to pending approval if not approved
    if (!authStore.currentUser?.approved) {
      next({ name: 'PendingApproval' })
    } else {
      next({ name: 'Dashboard' })
    }
    return
  }

  // Route requires approval
  if (to.meta.requiresApproval && authStore.isLoggedIn && !authStore.currentUser?.approved) {
    next({ name: 'PendingApproval' })
    return
  }

  // If user is approved and tries to access pending approval page, redirect to dashboard
  if (to.name === 'PendingApproval' && authStore.currentUser?.approved) {
    next({ name: 'Dashboard' })
    return
  }

  next()
})

export default router